import { IconsEnum } from 'components/Icons';
import { Spinner } from 'components/spinner';
import { menuApi } from 'features/api/menuApiSlice';
import { doFetch } from 'features/api/thunkUtils';
import { useAppDispatch } from 'lib/centralStore';
import React, { memo, useEffect, useRef } from 'react';
import { isTruthy } from 'utility/functions';
import { useDisciplina } from '../../hooks';
import { BaseMenuItem, LIVE_DISCIPLINA_DETAILS } from '../../types';
import { LiveManifestazioneMenuItem } from '../liveManifestazioneMenuItem/LiveManifestazioneMenuItem';
import { LiveNavAccordion } from '../liveNavAccordion/LiveNavAccordion';
import styleNavFavouriteMenuItem from '../liveNavFavouriteMenuItem/LiveNavFavouriteMenuItem.module.scss';
import { useIsomorphicLayoutEffect } from 'hooks';

interface ManifestazioniProps extends Pick<BaseMenuItem, 'id'> {
  isLoading?: boolean;
  manifestazioni?: BaseMenuItem[];
}
const Manifestazioni = ({ id }: ManifestazioniProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const refExpandedStatus = useRef(false);

  const { slug, isLoading, isExpanded, manifestazioni } = useDisciplina(id, true);

  useIsomorphicLayoutEffect(() => {
    if (refExpandedStatus.current !== isExpanded) {
      refExpandedStatus.current = isExpanded;

      if (isExpanded) {
        dispatch(
          doFetch({
            id,
            uid: LIVE_DISCIPLINA_DETAILS,
            slug,
            query: menuApi.endpoints.getDisciplinaDetails,
            paramAsObject: true,
          })
        );
      }
    }
  }, [id, slug, isExpanded, dispatch]);

  if (isLoading || manifestazioni?.length === 0) {
    return <Spinner key={`spinner-${id}-loading`} className={styleNavFavouriteMenuItem.loading} />;
  }

  return (
    <React.Fragment key={`content-${id}-fulfilled`}>
      {manifestazioni?.map((manifestazione) =>
        isTruthy(manifestazione.counter) ? (
          <LiveManifestazioneMenuItem {...manifestazione} key={`${id}-${manifestazione.id}`} idDisciplina={id!} />
        ) : (
          <React.Fragment key={`${id}-${manifestazione.id}`} />
        )
      )}
    </React.Fragment>
  );
};

export const LiveDisciplinaMenuItem = memo(
  function LiveDisciplinaMenuItem({ id }: BaseMenuItem): JSX.Element {
    const { counter, isExpanded, descrizione, descrizioneTrKey } = useDisciplina(id, true);

    if ((counter ?? 0) < 1) {
      return <React.Fragment key={`dis-${id}`} />;
    }

    return (
      <LiveNavAccordion
        key={id}
        icon={IconsEnum.CHEVRON_DOWN}
        entryId={`${id}`}
        counter={counter}
        idDisciplina={id}
        description={descrizione}
        descriptionTrKey={descrizioneTrKey}
      >
        <Manifestazioni id={id} key={`${id}-${isExpanded}`} />
      </LiveNavAccordion>
    );
  },
  (prevProps, nextProps) => prevProps.id === nextProps.id
);
